module.exports = __webpack_public_path__ + "img/Vector 8.c3c229c4.png";